import { c as _c } from "react/compiler-runtime";
import cn from 'classnames';
import { useState } from 'react';
import Svg from 'react-inlinesvg';
import BlurTooltip from '../../../blur-tooltip/BlurTooltip';
import style from './BlurTooltipMap.module.scss';
function BlurTooltipMap(t0) {
  const $ = _c(16);
  const {
    children,
    someStyles,
    svg,
    title,
    isMobile
  } = t0;
  const [showTitle, setShowTitle] = useState(false);
  let t1;
  if ($[0] !== someStyles) {
    t1 = cn(someStyles);
    $[0] = someStyles;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== isMobile || $[3] !== showTitle) {
    t2 = () => isMobile ? setShowTitle(!showTitle) : null;
    $[2] = isMobile;
    $[3] = showTitle;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setShowTitle(true);
    t4 = () => setShowTitle(false);
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  let t5;
  if ($[7] !== children || $[8] !== showTitle || $[9] !== svg || $[10] !== title) {
    t5 = children || <div className={cn(style.svgBlock, showTitle ? style.svgOpen : style.svgClose)}><div className={cn(style.icon)}><Svg src={svg.src} className={style.icon__svg} /></div><span className={style.titleSvg}>{title}</span></div>;
    $[7] = children;
    $[8] = showTitle;
    $[9] = svg;
    $[10] = title;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t1 || $[13] !== t2 || $[14] !== t5) {
    t6 = <><BlurTooltip someStyles={t1} onTouchStart={t2} onMouseOver={t3} onMouseLeave={t4}>{t5}</BlurTooltip></>;
    $[12] = t1;
    $[13] = t2;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
}
export default BlurTooltipMap;